<ul>
  <li *ngFor="let author of authors; let i=index">
    <app-ask-the-author-list-item [author]="author" [index]="i"></app-ask-the-author-list-item>
  </li>
</ul>
